var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMineCardsLogoRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48C28 36.9543 36.9543 28 48 28H60C71.0457 28 80 36.9543 80 48V60C80 71.0457 71.0457 80 60 80H48C36.9543 80 28 71.0457 28 60V48Z",
    fill: "#1F1F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8698 22.5411L47.6875 20.4574C58.0215 18.6352 67.876 25.5354 69.6982 35.8694L71.7819 47.6871C73.6041 58.0211 66.7039 67.8756 56.3699 69.6978L44.5522 71.7815C34.2182 73.6037 24.3637 66.7035 22.5415 56.3695L20.4578 44.5518C18.6356 34.2178 25.5358 24.3633 35.8698 22.5411Z",
    fill: "#CEFF1A",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMineCardsLogoRounded);
export default __webpack_public_path__ + "static/media/MineCards-Logo-Rounded.82daa51e7551b5e3d1ece81b43f1ffa2.svg";
export { ForwardRef as ReactComponent };